import React from 'react'
import PropTypes from 'prop-types'
import { ButtonStatus, StyledMenu } from '../../TradeBlotter.style'
import { useMemo } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { MenuItem } from '@mui/material'
import { CheckboxStyle } from '../../../../components/styled/global.style'

const MenuStatus = ({ isUserBooking, handelStatusFilterChange, filters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const MENU_ITEMS = useMemo(
    () => ({
      NEW: 'is_new',
      AMENDMENTS: 'is_amended',
      DELETIONS: 'is_delete'
    }),
    []
  )

  const handelClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handelClickMenuItem = (event, name) => {
    event.target.checked = !filters.deal_status[name]
    event.target.name = name
    handelStatusFilterChange(event)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <ButtonStatus
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        onClick={handelClick}
        disabled={!isUserBooking()}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Status
      </ButtonStatus>
      <StyledMenu
        anchorEl={anchorEl}
        style={{ overflow: 'hidden' }}
        open={open}
        onClose={handleClose}
        backgroundcolor={'#242428'}
      >
        <MenuItem disableRipple onClick={event => handelClickMenuItem(event, MENU_ITEMS.NEW)}>
          <CheckboxStyle
            checked={filters.deal_status[MENU_ITEMS.NEW]}
            name={MENU_ITEMS.NEW}
          ></CheckboxStyle>
          {'New'}
        </MenuItem>
        <MenuItem
          disableRipple
          onClick={event => handelClickMenuItem(event, MENU_ITEMS.AMENDMENTS)}
        >
          <CheckboxStyle
            checked={filters.deal_status[MENU_ITEMS.AMENDMENTS]}
            name={MENU_ITEMS.AMENDMENTS}
          ></CheckboxStyle>
          {'Amendments'}
        </MenuItem>
        <MenuItem disableRipple onClick={event => handelClickMenuItem(event, MENU_ITEMS.DELETIONS)}>
          <CheckboxStyle
            checked={filters.deal_status[MENU_ITEMS.DELETIONS]}
            name={MENU_ITEMS.DELETIONS}
          ></CheckboxStyle>
          {'Deletions'}
        </MenuItem>
      </StyledMenu>
    </>
  )
}

export default MenuStatus

MenuStatus.propTypes = {
  isUserBooking: PropTypes.func,
  handelStatusFilterChange: PropTypes.func,
  filters: PropTypes.object
}
